<template>
  <div class="container page">
    <van-nav-bar class="nav-bar" :title="$t('任务记录Title')">
      <template #left>
        <van-icon color="#fff" name="arrow-left" @click="$router.back()" />
      </template>
    </van-nav-bar>
    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" :description="$t('数据为空') + '！'" />
        <template v-else>
          <van-list ref="vanList" v-model="loading" :finished="finished" :finished-text="$t('没有更多了')" :immediate-check="false" @load="onLoad">
            <div v-for="(v, key) in list" @click="onGameClick(v)" :key="key" class="item_list">
              <div class="lottery_info">
                <van-image :src="BASE_URL + v.ico" class="cover">
                  <template v-slot:loading>
                    <van-loading type="spinner" />
                  </template>
                </van-image>
                <span class="period-number">{{ v.name }}</span>
              </div>
              <div style="text-align: left;margin-left: 0" class="period-number">{{ v.expect }}</div>
              <div class="recent">
                <div class="kuaisan-ball left">
                  <!--<van-image :src=" v.status === 0 ? 'img/lottery/open_num.gif' : 'img/lottery/shaizi/' + v.opencode[0] + '.png' "-->
                  <!--           class="res-img">-->
                  <!--  <template v-slot:loading>-->
                  <!--    <van-loading type="spinner"/>-->
                  <!--  </template>-->
                  <!--</van-image>-->
                  <!--<van-image :src=" v.status === 0 ? 'img/lottery/open_num.gif' : 'img/lottery/shaizi/' + v.opencode[1] + '.png' "-->
                  <!--           class="res-img">-->
                  <!--  <template v-slot:loading>-->
                  <!--    <van-loading type="spinner"/>-->
                  <!--  </template>-->
                  <!--</van-image>-->
                  <!--<van-image :src=" v.status === 0 ? 'img/lottery/open_num.gif' : 'img/lottery/shaizi/' + v.opencode[2] + '.png' "-->
                  <!--           class="res-img">-->
                  <!--  <template v-slot:loading>-->
                  <!--    <van-loading type="spinner"/>-->
                  <!--  </template>-->
                  <!--</van-image>-->

                  <span class="res-des middle sum">{{
                    v.status === 0 ? 0 : v.opencode[0] + v.opencode[1] + v.opencode[2]
                  }}</span>
                  <span class="res-des middle option">{{ v.status === 0 ? 0 : v.result1Text }}</span>
                  <span class="res-des middle option">{{ v.status === 0 ? 0 : v.result2Text }}</span>
                </div>
              </div>
              <div class="topInfo">
                <span v-if="v.status === 1" style="color: #07c160">{{ v.status_text }}</span>
                <span v-else>{{ v.status_text }}</span>
              </div>
              <!--   <div class="topInfo">
               <span v-if="v.is_win === 1" style="color: #07c160">{{v.win_text}}</span>
               <span v-else >{{v.win_text}}</span>
               <span>金额：{{v.profit}}</span>
             </div> -->
              <!-- <div class="topInfo">
            <span>任务类型：</span>
            <span>{{v.type}}</span>
          </div> -->
              <div class="time">
                <span>{{ $t('下单时间') }}：{{ v.create_time }}</span>
              </div>
              <div class="time">
                <span>{{ $t('结算时间') }}：{{ v.update_time }}</span>
              </div>
              <span class="amount">{{ $t('投票金额') }}：{{ v.money }}</span>
            </div>
          </van-list>
        </template>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
      lottery_peilv_list: [],
      BASE_URL: process.env.VUE_APP_BASE_URL,
      loading: false,
      finished: false,
      page: 1,
      isRequesting: false // 防止重复请求的标志位
    }
  },
  methods: {
    onLoad() {
      console.log('onLoad 被触发', { finished: this.finished, isRequesting: this.isRequesting, page: this.page })
      // 如果已经加载完成或正在请求中，不再请求
      if (this.finished || this.isRequesting) {
        console.log('onLoad 被阻止，原因：', this.finished ? '已完成' : '正在请求中')
        return
      }
      console.log('开始加载第', this.page, '页')
      this.getUserGameList()
    },
    getLotteryPeilv(id) {
      return new Promise((resolve) => {
        this.$http({
          method: 'get',
          data: { id },
          url: 'lottery_get_peilv'
        }).then((res) => {
          if (res.code === 200) {
            resolve(res.data)
            console.log('=>(GameRecord.vue:124) res.data', res.data)
          } else if (res.code === 401) {
            this.$toast(res.msg)
          }
        })
      })
    },

    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t('刷新成功') + '！')
        this.page = 1
        this.finished = false
        this.list = []
        this.isRequesting = false
        this.getUserGameList()
        this.isLoading = false
      }, 500)
    },
    async initOption(list) {
      const uniqueLids = [...new Set(list.map((item) => item.data[0].lid))]
      let optionList = {}

      await Promise.all(
        uniqueLids.map(async (id) => {
          optionList['option' + id] = await this.getLotteryPeilv(id)
        })
      )

      list.map((item) => {
        let result1, result2
        if (item.status == 0) {
          result1 = 0
          result2 = 0
          item.result1Text = '0'
          item.result2Text = '0'
        } else {
          result1 =
            item.opencode[0] + item.opencode[1] + item.opencode[2] >= 11 &&
            item.opencode[0] + item.opencode[1] + item.opencode[2] <= 18
              ? '大'
              : '小'
          result2 = (item.opencode[0] + item.opencode[1] + item.opencode[2]) % 2 === 0 ? '双' : '单'
          item.result1Text = optionList['option' + item.data[0].lid].filter((item) => item.type === result1)[0].name
          item.result2Text = optionList['option' + item.data[0].lid].filter((item) => item.type === result2)[0].name
        }

        return item
      })
      
      // 如果是第一页，替换数据；否则追加数据
      if (this.page === 1) {
        this.list = list
      } else {
        this.list = this.list.concat(list)
      }
      this.$toast.clear()
    },
    getUserGameList() {
      console.log('getUserGameList 开始', { page: this.page, isRequesting: this.isRequesting })
      this.$toast.loading({ message: this.$t('Loading...'), duration: 0 })
      this.loading = true
      this.isRequesting = true
      this.$http({
        method: 'get',
        data: { page: this.page },
        url: 'user_get_game_list'
      })
        .then(async (res) => {
          console.log('🚀 ~ getUserGameList ~ res:', res)

          const { current_page, total_pages } = res.pagination
          if (current_page >= total_pages || res.data.length === 0) {
            this.finished = true
          } else {
            this.finished = false
          }
          if (res.code === 200) {
            // 如果数据为空，标记为加载完成
            if (!res.data || res.data.length === 0) {
              this.finished = true
            } else {
              // 等待数据处理完成后再递增页码
              await this.initOption(res.data)
              this.page++
              console.log('数据处理完成，页码递增到:', this.page)
            }
          } else if (res.code === 401) {
            this.$toast(res.msg)
          }
        })
        .finally(() => {
          console.log('finnal2 - 请求结束，重置状态')
          this.$toast.clear()
          this.loading = false
          this.isRequesting = false
          
          // 数据加载完成后，让 van-list 检查是否需要继续加载
          this.$nextTick(() => {
            if (this.$refs.vanList && !this.finished) {
              console.log('手动触发 van-list 检查')
              this.$refs.vanList.check()
            }
          })
        })
    },
    onGameClick(gameInfo) {
      window.localStorage.setItem('gameInfo', JSON.stringify(gameInfo))
      this.$router.push('/GameDetail')
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      // 初始化加载第一页数据，设置初始状态避免与 onLoad 冲突
      this.isRequesting = true
      this.getUserGameList()
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/base.css';

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}

.container .main {
  position: relative;
  overflow: hidden;
  background-color: #f2f2f5;
  height: calc(100vh - 110px);
  padding: 0 10px;
}

.item_list {
  padding: 15px 15px;
  margin: 30px 10px;
  background: #fff;
  border-radius: 10px;
  line-height: 60px;
}

.item_list .topInfo span {
  flex: 1;
  font-size: 35px;
  font-weight: 700;
  color: #ff253f;
}

.item_list .time span {
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #000;
}

.amount {
  flex: 1;
  font-size: 35px;
  font-weight: 700;
  color: #ff253f;
}

.item_list .desc span {
  font-size: 25px;
  font-weight: 700;
  color: #9b9b9b;
}

.item_list .cover {
  width: 80px;
  height: 80px;
  -o-object-fit: cover;
  object-fit: cover;
}

.item_list .period-number {
  flex: 1;
  text-align: right;
  margin-left: 50px;
  margin-right: 10px;
  height: 50px;
  line-height: 60px;
  font-size: 32px;
  font-weight: 700;
  color: #000;
  white-space: nowrap;
}

.item_list .lottery_info {
  display: flex;
}

.recent {
  display: flex;
  align-items: center;
  height: 100px;
}

.kuaisan-ball .left {
  justify-content: flex-start;
}

.kuaisan-ball {
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img {
  width: 70px;
  height: 70px;
  margin-right: 30px;
}

.kuaisan-ball .res-des {
  font-weight: 700;
  text-align: center;
  color: #000;
}

.kuaisan-ball .res-des.middle {
  font-size: 35px;
  margin-right: 20px;
}
.sum {
  width: 52px;
  height: 52px;
  text-align: center;
  line-height: 52px;
  color: #fff !important;
  border-radius: 50%;
  background-color: #eaa07b;
}

.option {
  font-weight: 700;
  text-align: center;
  background: linear-gradient(90deg, #7e5678, #e6c3a1);
  color: #fff !important;
  padding: 0 10px;
  height: 7vw;
  line-height: 7vw;
  font-size: 3vw;
  margin-right: 4vw;
  border-radius: 10px;
}

::v-deep .van-pull-refresh {
  overflow: auto;
  height: calc(100vh - 200px);
}

::v-deep .van-pull-refresh__track {
  height: calc(100vh - 200px);
}

::v-deep .van-list {
  height: calc(100vh - 110px);
}
::v-deep .van-list__finished-text {
  font-size: 26px
}

// PC端适配：重置vw为px值，并适配430px宽度 (比例: 430/750 = 0.5733)
@media (min-width: 768px) {
  // 导航栏PC端适配
  .nav-bar {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar {
    line-height: 57px !important;
  }

  ::v-deep .van-nav-bar__content {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar__title {
    font-size: 20px !important; /* 35px * 0.5733 ≈ 20px */
    max-width: 60% !important;
  }

  ::v-deep .van-nav-bar .van-icon {
    font-size: 26px !important; /* 45px * 0.5733 ≈ 26px */
  }

  // 下拉刷新PC端适配
  ::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
  }

  ::v-deep .van-loading__text {
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
  }

  // 主内容区域PC端适配
  .container .main {
    height: calc(100vh - 63px); /* 110px * 0.5733 ≈ 63px */
    padding: 0 6px; /* 10px * 0.5733 ≈ 6px */
  }

  // 列表项PC端适配
  .item_list {
    padding: 9px 9px; /* 15px * 0.5733 ≈ 9px */
    margin: 17px 6px; /* 30px * 0.5733 ≈ 17px, 10px * 0.5733 ≈ 6px */
    border-radius: 6px; /* 10px * 0.5733 ≈ 6px */
    line-height: 34px; /* 60px * 0.5733 ≈ 34px */
  }

  .item_list .topInfo span {
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
  }

  .item_list .time span {
    font-size: 14px; /* 25px * 0.5733 ≈ 14px */
  }

  .amount {
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
  }

  .item_list .desc span {
    font-size: 14px; /* 25px * 0.5733 ≈ 14px */
  }

  .item_list .cover {
    width: 46px; /* 80px * 0.5733 ≈ 46px */
    height: 46px; /* 80px * 0.5733 ≈ 46px */
  }

  .item_list .period-number {
    margin-left: 29px; /* 50px * 0.5733 ≈ 29px */
    margin-right: 6px; /* 10px * 0.5733 ≈ 6px */
    height: 29px; /* 50px * 0.5733 ≈ 29px */
    line-height: 34px; /* 60px * 0.5733 ≈ 34px */
    font-size: 18px; /* 32px * 0.5733 ≈ 18px */
  }

  .recent {
    height: 57px; /* 100px * 0.5733 ≈ 57px */
  }

  .kuaisan-ball .res-img {
    width: 40px; /* 70px * 0.5733 ≈ 40px */
    height: 40px; /* 70px * 0.5733 ≈ 40px */
    margin-right: 17px; /* 30px * 0.5733 ≈ 17px */
  }

  .kuaisan-ball .res-des.middle {
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
    margin-right: 11px; /* 20px * 0.5733 ≈ 11px */
  }

  .sum {
    width: 30px; /* 52px * 0.5733 ≈ 30px */
    height: 30px; /* 52px * 0.5733 ≈ 30px */
    line-height: 30px; /* 52px * 0.5733 ≈ 30px */
  }

  .option {
    padding: 0 6px; /* 10px * 0.5733 ≈ 6px */
    height: 40px; /* 7vw * 0.5733 ≈ 40px */
    line-height: 40px; /* 7vw * 0.5733 ≈ 40px */
    font-size: 17px; /* 3vw * 0.5733 ≈ 17px */
    margin-right: 23px; /* 4vw * 0.5733 ≈ 23px */
    border-radius: 6px; /* 10px * 0.5733 ≈ 6px */
  }

  ::v-deep .van-list__finished-text {
    font-size: 15px; /* 26px * 0.5733 ≈ 15px */
  }

  // 空状态PC端适配
  ::v-deep .van-empty__image {
    width: 172px !important; /* 300px * 0.5733 ≈ 172px */
    height: 172px !important; /* 300px * 0.5733 ≈ 172px */
  }

  ::v-deep .van-empty__description {
    font-size: 17px !important; /* 30px * 0.5733 ≈ 17px */
  }
}
</style>
